module.exports = __webpack_public_path__ + "static/media/PingFangSC-Regular.218e7a59.woff2";